/**
 * The responsibility of this file is to make a reusable component for the sidebar menu list collapse.
 * It has many children(ListItem).
 * In short it group the list items in a collapsible manner.
 */

import * as React from 'react';
import { Link } from 'react-router-dom';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

export default function ListCollapse({
    // onSelect,
    selectedChildUrl,
    // isSelected,
    children = list,
    tabName = 'Dashboard',
    icon = <DashboardIcon />,
    shouldEnabledMenu = true
}) {
    const [open, setOpen] = React.useState(false);

    // check if any child is selected to mark parent list button as selected
    // wrapped in useMemo to avoid unnecessary re-renders
    // const isAnyChildSelected = React.useMemo(() => {
    //     console.log("Children IDs:", children.map(item => item.id));
    //     console.log("Selected ID:", isSelected);
    //     return children.some((item) => isSelected === item.id);
    // }, [children, isSelected]);

    // console.log("Is Selected : ", isSelected);
    const isAnyChildSelected = React.useMemo(
        () => children.some((child) => child.url === selectedChildUrl),
        [children, selectedChildUrl]
    );

    React.useEffect(() => {
        if (isAnyChildSelected) {
            setOpen(true);
        }
    }, [isAnyChildSelected]);

    return (
        <List component="nav" sx={listStyle} aria-labelledby="listCollapse">
            <ListItemButton
                disableRipple
                variant="dashboardListItem"
                selected={isAnyChildSelected}
                onClick={() => setOpen(!open)}
                // disabled={!shouldEnabledMenu}
            >
                {/* set the icon color conditionally if menu is selected */}
                <ListItemIcon>
                    {React.cloneElement(icon, {
                        color: isAnyChildSelected ? 'secondary' : 'inherit'
                    })}
                </ListItemIcon>
                <ListItemText primary={tabName} />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            {/* Collapsable List with all the sub list items */}
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding sx={verticleLine}>
                    {children.map((item) => {
                        return (
                            <ListItemButton
                                key={item.id}
                                component={Link}
                                to={item.url}
                                disableRipple
                                variant="dashboardListCollapse"
                                selected={item.url === selectedChildUrl}
                                sx={{ pointerEvents: item.enabled ? 'auto' : 'none' }}
                                disabled={!item.enabled}
                            >
                                <ListItemIcon sx={listIcon}>
                                    <FiberManualRecordIcon sx={listDotIcon} />
                                </ListItemIcon>
                                <ListItemText primary={item.title} />
                            </ListItemButton>
                        );
                    })}
                </List>
            </Collapse>
        </List>
    );
}

const list = [
    {
        id: 'eventDetails',
        title: 'Event details',
        type: 'item',
        icon: <DashboardIcon />,
        url: '/event-dashboard/event-details'
    },
    {
        id: 'tickets',
        title: 'Tickets',
        type: 'item',
        icon: <DashboardIcon />,
        url: '/event-dashboard/tickets'
    }
];

const listIcon = {
    '&.MuiListItemIcon-root': {
        minWidth: '26px'
    }
};

const listDotIcon = {
    fontSize: '0.625rem',
    color: '#f8a21e'
};

const listStyle = {
    width: '100%',
    maxWidth: 280,
    padding: 0
};

const verticleLine = {
    position: 'relative',
    // color: '#f5f5f5',
    '&:after': {
        content: "''",
        position: 'absolute',
        left: '28px',
        top: '0px',
        height: '100%',
        width: '0.5px',
        background: 'var(--divider-color)'
    }
};
